const BASE_URL = process.env.REACT_APP_API_CALL_BASE_URL;
// ---------------------------------------------------------------------------------------------
//////////////////////////////////CLINICS///////////////////////
// ---------------------------------------------------------------------------------------------
export const onboardClinic = async(clinicData, token) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/onboard/clinic`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`      
        },
        body: JSON.stringify(clinicData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Error ${response.status}: ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error onboarding clinic', error);
      throw error
    }
};

// Get details of specifc clinic for clinic overview page
export const getClinicDetails = async(clinicId, token) => {
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };

  try {
    // Get clinic Info
    const clinicResponse = await fetch(`${BASE_URL}/invoco/clinics/${clinicId}`, { headers });
    if (!clinicResponse.ok) throw new Error(`Failed to fetch Clinic Info: ${clinicResponse.status}`);
    const clinicData = await clinicResponse.json();  

    //Get location info
    const locationResponse = await fetch(`${BASE_URL}/invoco/locations?clinic_id=${clinicId}`, { headers });
    const locationData = await locationResponse.json();

    // Fetch rooms and doctors for each location
    const locationDetails = await Promise.all(
      locationData.map(async (location) => {
        const [roomsResponse, doctorResponse] = await Promise.all([
          fetch(`${BASE_URL}/invoco/rooms?location_id=${location.location_id}&include_inactive=true`, { headers }),
          fetch(`${BASE_URL}/invoco/doctors?location_id=${location.location_id}&include_inactive=true`, { headers }),
        ]);

        const rooms = roomsResponse.ok ? await roomsResponse.json() : [];
        const doctors = doctorResponse.ok ? await doctorResponse.json() : [];
        // Get user Data from each location (awaiting API update)
        return { ...location, rooms, doctors };
      })
    )
    return {
      ...clinicData.clinic,
      locations: locationDetails,
    }

   
  } catch (error) {
    console.error(error);
    throw error;
  }

}

//Deactivate Clinic
export const deactivateClinic = async (clinicId, token) => {
  const response = await fetch(`${BASE_URL}/invoco/clinics/${clinicId}/deactivate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to deactivate clinic');
  }

  return await response.json();
}

//Reactivate Clinic
export const reactivateClinic = async (clinicId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/clinics/${clinicId}/reactivate`, {
      method: 'PATCH', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to reactivate clinic: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error reactivating clinic:', error);
    throw new Error(error.detail || 'Failed to reactivate clinic');
  }
}

// Super Admin All Clinics Fetch 
export async function fetchClinic(user, token, setClinics, includeInactive = false) {
  try {
    const params = new URLSearchParams();

    if (includeInactive && user?.role === 'super_admin') {
      params.append('include_inactive', true);
    }

    const queryString = params.toString() ? `?${params.toString()}` : '';

    const response = await fetch(`${BASE_URL}/invoco/clinics${queryString}`, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch clinics: ${response.status}`);
    }
    const data = await response.json();
    setClinics(data);
  } catch (error) {
    console.error('Error fetching clinics', error);
  }
}

// ---------------------------------------------------------------------------------------------
//////////////////////////////////ROOMS///////////////////////
// ---------------------------------------------------------------------------------------------

// GET List rooms - GET all rooms associated with location_id
export const fetchRooms = async(location_id, token, setRooms) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/rooms?location_id=${location_id}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) {
        throw new Error(`Error fetching room data`, response.statusText);
      }

      const data = await response.json();
      setRooms(data);      
    } catch (error) {
      console.log('Error fetching room data', error);
    }
  }

//Deactivate rooom
export const deactivateRoom = async (roomId, token) => {
  const response = await fetch(`${BASE_URL}/invoco/rooms/${roomId}/deactivate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to deactivate room');
  }

  return await response.json();
}

//Reactivate room
export const reactivateRoom = async (roomId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/rooms/${roomId}/reactivate`, {
      method: 'PATCH', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to reactivate room: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error reactivating room:', error);
    throw new Error(error.detail || 'Failed to reactivate room');
  }
}

// ---------------------------------------------------------------------------------------------
//////////////////////////////////USER DASHBOARD LOCATION/ROOM INFO///////////////////////
// ---------------------------------------------------------------------------------------------
export const fetchUserLocation = async (token, locationId) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/locations?location_id=${locationId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to fetch information, please see your administrator`)
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching user location information');
  }
}

// ---------------------------------------------------------------------------------------------
//////////////////////////////////DOCTORS///////////////////////
// ---------------------------------------------------------------------------------------------

// GET doctors
export const fetchDoctors = async(location_id, token, colorClasses, setDoctors) => {
    try {
    const response = await fetch(`${BASE_URL}/invoco/doctors?location_id=${location_id}`, {
        method: 'GET',
            headers: {
            Authorization: `Bearer ${token}`
        },
    });
    if (!response.ok) {
        throw new Error(`Error fetching doctor data`, response.statusText);
    }
    const data = await response.json();
  
    //assign a doctor a color
    const docCards = data.map((doctor, index) => ({
        ...doctor,
        ...colorClasses[index % colorClasses.length]
    }));
  
    setDoctors(docCards);
    } catch (error) {
        console.log('Error fetching doctor data', error);
    }
}

//Onboard doctor/user and send invite
export const onboardDoctor = async (doctorData, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/onboard/user`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(doctorData),
    });
    if (!response.ok) {
      let errorMessage = 'Failed to onboard doctor';
      try {
        const errorData = await response.json();
        if (errorData?.message) {
          errorMessage = errorData.message;
        } 
      } catch {
      }
      throw new Error(errorMessage);
    };
    return await response.json();
  } catch (error) {
    console.error('Error inviting User', error);
    throw error;
  }
};

//Deactivate doctor
export const deactivateDoctor = async (doctorId, token) => {
  const response = await fetch(`${BASE_URL}/invoco/doctors/${doctorId}/deactivate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to deactivate Doctor');
  }

  return await response.json();
}

//Reactivate doctor
export const reactivateDoctor = async (doctorId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/doctors/${doctorId}/reactivate`, {
      method: 'PATCH', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to reactivate doctor: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error reactivating doctor:', error);
    throw new Error(error.detail || 'Failed to reactivate doctor');
  }
}

// ---------------------------------------------------------------------------------------------
//////////////////////////////////LOCATIONS///////////////////////
// ---------------------------------------------------------------------------------------------

// GET Location - GET request to get all locations associated with a clinic and also get ONE location with location_id
export const fetchLocations = async(token, setLocations) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/locations`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching location data`, response.statusText);
    }

    const data = await response.json();
    setLocations(data);
  } catch(error) {
    console.log('Error fetching locaiton data', error);
  }
}

// GET Location by Clinic ID
export const fetchLocationsByClinic = async(clinicID, token, setLocations) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/locations?clinic_id=${clinicID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Error fetching location data: ${response.statusText}`);
    }

    const data = await response.json();
    setLocations(data);
  } catch (error) {
    console.error('Error fetching location data', error, error.status);
  }
};

//Deactivate location
export const deactivateLocation = async (locationId, token) => {
  const response = await fetch(`${BASE_URL}/invoco/locations/${locationId}/deactivate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to deactivate location');
  }

  return await response.json();
}

//Reactivate location
export const reactivateLocation = async (locationId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/locations/${locationId}/reactivate`, {
      method: 'PATCH', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to reactivate location: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error reactivating location:', error);
    throw new Error(error.detail || 'Failed to reactivate location');
  }
}


// ---------------------------------------------------------------------------------------------
//////////////////////////////////ASSIGNMENTS/CALENDAR///////////////////////
// ---------------------------------------------------------------------------------------------
//GET any saved assignments
export const fetchSchedule = async(start, end, locationID, token) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/schedule?start=${start}&end=${end}&location_id=${locationID}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`
        },
      });
      if (!response.ok) {
        throw new Error(`Error: ${response.status}: ${response.statusText}`);
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.log('Error fetching schedule data', error);
    }
  }

// CALENDAR - SAVE ASSIGNMENT
export const saveAssignment = async (date, roomId, doctorId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/assignments`, {
        method: 'POST',
        headers: {
          "Content-Type": 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          assignments: [{ date, room_id: roomId, doctor_id: doctorId }]
        })
      });

      if (!response.ok) {
        throw new Error('Error saving assignment - ',response.status)
      }

      const data = await response.json();
      return (data.updated && data.updated[0]) || (data.created && data.created[0]);

    } catch (error ) {
      console.error('Save assignment failed', error)
    }
}

// ---------------------------------------------------------------------------------------------
//////////////////////////////////USER MANAGEMENT///////////////////////
// ---------------------------------------------------------------------------------------------
  //Activate user with invite token
  export const activateUser = async (inviteToken, password) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/users/activate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
          body: JSON.stringify({
            invite_token: inviteToken,
            password,
          }),
        }
      );
      const data = await response.json()

      if (!response.ok) throw new Error('Failed to activate user');

      return data;
    } catch (error) {
      console.error('Error activating user', error);
      throw error;
    }
  };

  // Admin or super admin only - send reset user password email
  export const sendResetUserPassword = async (userId, token) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/users/${userId}/password-reset`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error sending user password reset email');
      throw error;
    }
  }

  // RESEND Welcome Email
  export const resendInvite = async (token, userId) => {
    try {
      const response = await fetch(`${BASE_URL}/invoco/users/${userId}/resend-invite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        }
      });
      const data = await response.json();

      if (!response.ok) throw new Error('Failed to resend welcome email.');

      return data;
    } catch (error) {
      console.error('Error resending invite email', error);
      throw error;
    }
  };

//Deactivate User
export const deactivateUser = async (userId, token) => {
  const response = await fetch(`${BASE_URL}/invoco/users/${userId}/deactivate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Failed to deactivate User');
  }

  return await response.json();
}

//Reactivate User
export const reactivateUser = async (userId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/users/${userId}/reactivate`, {
      method: 'PATCH', 
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error(`Failed to reactivate user: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Error reactivating user:', error);
    throw new Error(error.detail || 'Failed to reactivate user');
  }
}

  //FETCH Users by location ID
export const fetchUsers = async (location_id, token, setUsers) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/users?location_id=${location_id}`, {
      method: 'GET',
      headers: {Authorization: `Bearer ${token}`},
    });
    if (!response.ok) throw new Error('Error fetching users');
    const data = await response.json();
    setUsers(data);
  } catch (error) {
    console.error('Error fetching users', error);
  }
};

//FETCH Users by Clinic ID NOTE - ASK FOR QUERY PARAM FOR BACKEND ?ROLE=ADMIN TO FETCH ONLY ADMIN DATA ASSOCIATED WITH CLINIC ID
export const fetchAdmins = async (clinic_id, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/users?clinic_id=${clinic_id}&include_inactive=true`, {
      method: 'GET',
      headers: {Authorization: `Bearer ${token}`},
    });
    if (!response.ok) throw new Error('Error fetching users');
    const data = await response.json();

    const admins = data.filter(user => user.role === 'admin');
    return admins;
  } catch (error) {
    console.error('Error fetching admin data', error)
  }
}

//GET USERS BY LOCATION
export const getUsersByLocation = async (locationId, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/users?location_id=${locationId}&include_inactive=true`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) throw new Error('Failed to fetch users');
    return await response.json();
  } catch (error) {
    console.error('Error fetching users', error);
    throw error;
  }
};

// CREATE USER NO DOCTOR
export const onboardUser = async (userData, token) => {
  try {
    const response = await fetch(`${BASE_URL}/invoco/users`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });
    if (!response.ok) {
      let errorMessage = 'Failed to onboard user - please contact support';
      try {
        const errorData = await response.json();
        if (errorData?.message) {
          errorMessage = errorData.message;
        } 
      } catch {

      }
      throw new Error(errorMessage);
    }
    return await response.json();
  } catch (error) {
    console.error('Error inviting User', error);
    throw error;
  }
};